import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { APP_TYPE, AppType } from "../../../constants/app";
import { FILE_UPLOAD, PageRoutes } from "../../../constants/routes";
import { authSelectors } from "../../../ducks/auth";
import { UserRole } from "../../../ducks/user";
import { useNavigation } from "../../../hooks/useNavigation";

export const useHome = () => {
  const { navigateToPage } = useNavigation();
  const loggedInUser = useSelector(authSelectors.loggedInUser);
  const [showNotRegister, setShowNotRegister] = useState<boolean>(false);

  useEffect(() => {
    if (!loggedInUser) return;

    if (APP_TYPE === AppType.FileUpload) {
      navigateToPage(
        PageRoutes.FILE_UPLOAD.replace(
          ":menuId",
          FILE_UPLOAD.COMMON_HUMAN_RESOURCE,
        ),
      );
    } else {
      switch (loggedInUser.role) {
        case UserRole.Admin:
          navigateToPage(PageRoutes.CLIENTS);
          break;
        case UserRole.GroupAdmin:
          navigateToPage(PageRoutes.GROUPS);
          break;
        default:
          setShowNotRegister(true);
          break;
      }
    }
  }, [loggedInUser]);

  return {
    showNotRegister,
  };
};
